import req from "@/utils/axios.js";
export default {
    // 客户生日列表
    getCustomerBirthdayList(data){
        return req.get("/wxShop/operation/birthday/remind/list",{
            ...data
        })
    }
}